import React from "react";
import {
  instanceMetaData,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow";
import InstanceSellerTableRow from "./InstanceSellerTableRow";
import InstanceContactTable from "./InstanceContactTable";

export default function InstanceSalesDataTable (data: instanceMetaData) {
  const renderContactTable = ({sales_contacts: salesContact}: instanceMetaData) => {
    if (salesContact) {
      return salesContact.map((entry) => InstanceSellerTableRow(entry));
    }
    return InstanceContactRow({
      rowEmail: "-",
      rowFirst: "-",
      rowLast: "-"
    })
  };

  return (
    <InstanceContactTable
      title="Sales"
      headers={
        InstanceContactRow({
          rowEmail: "Email",
          rowFirst: "First Name",
          rowLast: "Last Name"
        }, true)
      }
      tableData={renderContactTable(data)}
    />
  );
}